'use strict';

var GridToolbarSystemReoptimizationStatusDirective = function GridToolbarSystemReoptimizationStatusDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-reoptimization.html'),
    controller: 'GridToolbarSystemStatusReoptimizationController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarSystemReoptimizationStatusDirective.$inject = [];
module.exports = GridToolbarSystemReoptimizationStatusDirective;